import { ConfigProvider } from "antd";
import React from "react";
import ReactDOM from "react-dom/client";
import { Toaster } from "react-hot-toast";
import App from "./App";
import "./index.css";
import ReactQueryProvider from "./provider/react_query_provider";
import reportWebVitals from "./reportWebVitals";
import { MessageProvider } from "./provider/AntdNotification";
const ThemedApp = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#013BBE",
          colorInfo: "#013BBE",
          colorSuccess: "#059669",
          colorWarning: "#d97706",
          colorError: "#dc2626",
          // Single source of truth for corner rounding — buttons, inputs,
          // cards, modals etc. all read this token instead of each page
          // picking its own rounded-lg/rounded-xl radius.
          borderRadius: 8,
          // Single source of truth for form control height — Input, Select,
          // DatePicker, InputNumber, Button etc. all read this token, so
          // setting it once here keeps every form field the same height
          // app-wide instead of drifting per-page.
          controlHeight: 40,
        },
        components: {
          Divider: {
            colorSplit: "#013BBE",
          },
          Button: {
            // Ensures type="primary" buttons render in the brand color out
            // of the box — pages should never need ``
            // hacks to get a primary button on-brand.
            colorPrimary: "#013BBE",
            algorithm: true,
            primaryShadow: "none",
          },
        },
      }}
    >
      <App />
    </ConfigProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <MessageProvider>
      <ReactQueryProvider>
        <ThemedApp />
        <Toaster position="top-center" reverseOrder={false} />
      </ReactQueryProvider>
    </MessageProvider>
  </React.StrictMode>
);

reportWebVitals();
